let shapeIndex = 0;

function Shape(el) {
  this.el = el;
  // different SVG shapes
  this.paths = {
    squeezed: "M311 125C311 125 242.2 122 175 122C96.8 122 38 125 38 125C38 125 43 109.198 43 74.5C43 45.999 38 24 38 24C38 24 97 27 175 27C260 27 311 24 311 24C311 24 307 41.598 307 76C307 108.398 311 125 311 125Z",
    expanded: "M311 125C311 125 242.2 134 175 134C96.8 134 38 125 38 125C38 125 28 109.198 28 74.5C28 45.999 38 24 38 24C38 24 97 14 175 14C260 14 311 24 311 24C311 24 322 41.598 322 76C322 108.398 311 125 311 125Z",
    squared: "M311 125C311 125 242.2 125 175 125C96.8 125 38 125 38 125C38 125 38 109.198 38 74.5C38 45.999 38 24 38 24C38 24 97 24 175 24C260 24 311 24 311 24C311 24 311 41.598 311 76C311 108.398 311 125 311 125Z"
  };
  // Init the shape
  this.init();
}

// Init Shape
Shape.prototype.init = function() {

  if (this.el.classList.contains('shape-animation')) {
    return;
  }

  // Add position relative to the element
  this.el.style.position = 'relative';
  
  const svgID = `shape-svg-${shapeIndex++}`;
  const maskID = `shape-mask-${shapeIndex++}`;
  const clipPathID = `shape-clippath-${shapeIndex++}`;
  
  // Add to the content an svg and wrap original html  
  // Check if we should mask the content in the shape
  let newHTML = '';
  if (this.el.hasAttribute('data-shape-mask')) {
    newHTML = `
        <svg id="${svgID}" data-shape-svg width="100%" height="100%" viewBox="0 0 350 150" preserveAspectRatio="none" aria-hidden="true" style="display: block; position: absolute; width: 128%; height: 148%; top: -24%; left: -14%; pointer-events: none;">
          <defs>
            <mask id="${maskID}" maskUnits="userSpaceOnUse">
               <rect width="100%" height="100%" fill="white"></rect>
               <text dominant-baseline="middle" text-anchor="middle" font-size="${window.getComputedStyle(this.el).getPropertyValue('font-size')}" font-weight="${window.getComputedStyle(this.el).getPropertyValue('font-weight')}">${this.el.textContent}</text>
            </mask>
          </defs>
          <path d="${this.paths.squared}" mask="url(#${maskID})" fill="${window.getComputedStyle(this.el).getPropertyValue('background-color')}"></path>
        </svg>
        <span style="position: relative; z-index: 100; opacity: 0;">${this.el.innerHTML}</span>
    `;
    
  } else {
    newHTML = `
        <svg id="${svgID}" data-shape-svg width="100%" height="100%" viewBox="0 0 350 150" preserveAspectRatio="none" aria-hidden="true" style="display: block; position: absolute; width: 128%; height: 148%; top: -24%; left: -14%; pointer-events: none;">
            <path d="${this.paths.squared}" fill="${window.getComputedStyle(this.el).getPropertyValue('background-color')}" />
        </svg>
        <span style="position: relative; z-index: 3;">${this.el.innerHTML}</span>
    `;
  }
  this.el.innerHTML = newHTML.trim();
  // Get the newly added svg
  this.shapeEl = this.el.querySelector('svg[data-shape-svg]');
  // Init SnapSVG
  let s = Snap( this.shapeEl );
  this.shapePath = s.select('path');
  this.pathEl = this.el.querySelector('path');
  
  const scaleX = this.shapeEl.viewBox.baseVal.width / this.shapeEl.clientWidth;
  const scaleY = this.shapeEl.viewBox.baseVal.height / this.shapeEl.clientHeight;
  
  // Scale text in shape-mask
  if (this.el.hasAttribute('data-shape-mask')) {
    const textEl = this.el.querySelector('text');
  
    textEl.setAttribute("transform", "scale("+scaleX+","+scaleY+")");
    
    const x = this.shapeEl.clientWidth/2;
    const y = this.shapeEl.clientHeight/2;
    
    textEl.setAttribute("x", x);
    textEl.setAttribute("y", y);
  }
  
  // set stroke of shape based on border
  const borderWidth = parseInt(window.getComputedStyle(this.el).getPropertyValue('border-width'));
  if (borderWidth > 0) {
    const strokeWidth = borderWidth * (scaleX);
    const strokeColor = window.getComputedStyle(this.el).getPropertyValue('border-color');
    this.pathEl.setAttribute("stroke", strokeColor);
    this.pathEl.setAttribute("stroke-width", `${strokeWidth}px`);
  }
  
  // Remove the background, to show the shape instead
  this.el.style.background = 'none';
  // Remove the border, to show the shape stroke instead
  this.el.style.borderColor = 'transparent';
  
  // Set the default shape
  this.squeezedShape();
  
  // Init events listeners
  this.initEvents();

  this.el.classList.add('shape-animation');
};

// Init event listeners for the Shape
Shape.prototype.initEvents = function() {
  const clickableAttribute = 'data-shape-clickable';
  const hoverableAttribute = 'data-shape-hoverable';
  
  // If element has attribute data-shape-clickable, animate on click/touch
  if (this.el.hasAttribute(clickableAttribute)) {
    const clickableElement = (this.el.getAttribute(clickableAttribute) !== "") ? this.el.closest(this.el.getAttribute(clickableAttribute)) : this.el;
    const pressDown = this.expandedShape.bind(this);
    clickableElement.addEventListener( 'mousedown', pressDown );
    clickableElement.addEventListener( 'touchstart', pressDown, { passive: true } );

    const pressRelease = (this.el.hasAttribute(hoverableAttribute)) ? this.squaredShape.bind(this) : this.squeezedShape.bind(this);
    
    clickableElement.addEventListener( 'mouseup', pressRelease );
    clickableElement.addEventListener( 'touchend', pressRelease, { passive: true } ); 
  }
  
  // If element has attribute data-shape-hoverable, animate on hover
  if (this.el.hasAttribute(hoverableAttribute)) {
    const hoverableElement = (this.el.getAttribute(hoverableAttribute) !== "") ? this.el.closest(this.el.getAttribute(hoverableAttribute)) : this.el;
    hoverableElement.addEventListener( 'mouseover', this.squaredShape.bind(this) );
    hoverableElement.addEventListener( 'mouseout', this.squeezedShape.bind(this) );
  }
};

// Animate a squeezed shape
Shape.prototype.squeezedShape = function() {
  this.shapePath.stop().animate({'path': this.paths.squeezed}, 800, mina.elastic);
};

// Animate an expanded shape
Shape.prototype.expandedShape = function() {
  this.shapePath.stop().animate({'path': this.paths.expanded}, 800, mina.elastic);
};

// Animate a square shape
Shape.prototype.squaredShape = function() {
  this.shapePath.stop().animate({'path': this.paths.squared}, 800, mina.elastic);
};

function createShapes() {
  // Find all elements and create a new Shape
  [].slice.call(document.querySelectorAll('[data-shape]')).forEach(function(el) {
    new Shape(el);
  });
}

// After the window has finnished loding, do stuff
window.addEventListener('load', (event) => {
  
  createShapes();

  document.addEventListener('infinte-scroll:append', function () {
    createShapes();
  });

  document.addEventListener('facets-update:end', function () {
    createShapes();
  });
});
